/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link, Outlet } from "react-router-dom";
import BaseCom from "../../components/BaseCom";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import LoginModal from "./LoginModal";
import SignUpModal from "./SignUpModal";
import Auth from "../../shared/Auth";
import L from "../../components/Lang";
import { qreq } from "../../shared/qrequest";
import ForgotModal from "./ForgotModal";
import { Dropdown } from "react-bootstrap";

class LandingLayout extends BaseCom {


    componentDidMount() {
        this.notVanilla(null, () => {
            setTimeout(() => this.props.navigate('/admin'), 100);
        });

        this.importCSS('/css/landing/style.css');
        this.importCSS('/css/fontawesome/fontawesome.min.css');
        this.importCSS('/css/fontawesome/solid.css');
        this.importCSS('/css/fontawesome/brands.css');
        Auth.getLogin(u => {
            if (u) {
                this.props.navigate('/dashboard/home');
                this.setState({ user: u });
            }
            this.setState({ loaded: true });
        });
    }

    componentWillUnmount() {
        this.undefineCSS('/css/landing/style.css');
        this.undefineCSS('/css/fontawesome/fontawesome.min.css');
        this.undefineCSS('/css/fontawesome/solid.css');
        this.undefineCSS('/css/fontawesome/brands.css');
    }

    logout = async () => {
        try {
            await qreq.postAsync('/api/auth/logout');
            document.location.assign('/');
        }
        catch (e) {
            console.error(e);
        }
    }

    render() {
        if (!this.state.loaded) return;

        return (
            <>
                <LoginModal show={this.state.showLogin} onHide={() => this.setState({ showLogin: false })}
                    onSignUp={() => this.setState({ showLogin: false, showSignUp: true, showForgot: false })}
                    onForgot={() => this.setState({ showLogin: false, showSignUp: false, showForgot: true })} />
                <SignUpModal show={this.state.showSignUp} onHide={() => this.setState({ showSignUp: false })}
                    onLogin={() => this.setState({ showLogin: true, showSignUp: false, showForgot: false })} />
                <ForgotModal show={this.state.showForgot} onHide={() => this.setState({ showForgot: false })}
                    onLogin={() => this.setState({ showLogin: true, showSignUp: false, showForgot: false })} />
                <header className="navigation bg-tertiary">
                    <nav className="navbar navbar-expand-xl navbar-light fixed-top text-center py-3">
                        <div className="container">
                            <Link className="navbar-brand" to="/">
                                <img loading="prelaod" decoding="async" className="img-fluid" width="160" src="/img/landing/logo.png" alt="Logo" />
                            </Link>

                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"> <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                                    {!this.props.noMenu && <>
                                        <li className="nav-item"> <a className="nav-link" href="#home"><L>Home</L></a>
                                        </li>
                                        <li className="nav-item "> <a className="nav-link" href="#services"><L>Services</L></a>
                                        </li>
                                        <li className="nav-item "> <a className="nav-link" href="#about"><L>About</L></a>
                                        </li>
                                        <li className="nav-item "> <a className="nav-link" href="#biz"><L>Business Details</L></a>
                                        </li>
                                        <li className="nav-item "> <a className="nav-link" href="#contact"><L>Contact</L></a>
                                        </li>
                                    </>}
                                </ul>
                                {this.state.user ? <>
                                    <button onClick={this.logout} data-bs-toggle="modal" data-bs-target="#loginform" className="btn btn-outline-primary"><L>Logout</L></button>
                                </> : <>
                                    <button onClick={() => this.setState({ showLogin: true })} data-bs-toggle="modal" data-bs-target="#loginform" className="btn btn-outline-primary"><L>Log In</L></button>
                                    <button onClick={() => this.setState({ showSignUp: true })} data-bs-toggle="modal" data-bs-target="#applyLoan" className="btn btn-primary ms-2 ms-lg-3"><L>Sign Up</L></button>
                                </>}
                                <Dropdown className="ms-2">
                                    <Dropdown.Toggle>
                                        <L>{this.props.lang?.toUpperCase()}</L>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item role="button" onClick={() => this.props.setLang('en')}><img src="/img/flags/us.png" alt="" className="lang-flag" /> English</Dropdown.Item>
                                        <Dropdown.Item role="button" onClick={() => this.props.setLang('es')}><img src="/img/flags/pr.png" alt="" className="lang-flag" /> Espa&ntilde;ol</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>

                        </div>
                    </nav>
                </header>
                <Outlet />

                <footer className="section-sm bg-tertiary">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-lg-2 col-md-4 col-6 mb-4">
                                <div className="footer-widget">
                                    <h5 className="mb-4 text-primary font-secondary">More Services</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><a href="https://taplocalnow.com/payments/accept-credit-cards/"><L>Accept Credit Cards</L></a>
                                        </li>
                                        <li className="mb-2"><a href="https://taplocalnow.com/local-seo-services/"><L>Manage Digital Presence</L></a>
                                        </li>
                                        <li className="mb-2"><a href="https://taplocalnow.com/get-more-customers/"><L>Ai-based Advertizing</L></a>
                                        </li>
                                        <li className="mb-2"><a href="https://taplocalnow.com/review-generation-2/"><L>Reputation Building</L></a>
                                        </li>
                                        <li className="mb-2"><a href="https://taplocalnow.com/text-messaging-service-for-business/"><L>SMS Advertizing</L></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-4 col-6 mb-4">
                                <div className="footer-widget">
                                    <h5 className="mb-4 text-primary font-secondary"><L>More About Us</L></h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><a href="https://taplocalnow.com/about-us-2/"><L>About Us</L></a>
                                        </li>
                                        <li className="mb-2"><a href="https://taplocalnow.com/meet-the-team/"><L>Meet The Team</L></a>
                                        </li>
                                        <li className="mb-2"><a href="https://taplocalnow.com/blog/client-success/"><L>Success Stories</L></a>
                                        </li>
                                        <li className="mb-2"><a href="https://taplocalnow.com/taplocal-marketing-reviews/"><L>Testimonials</L></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-4 col-6 mb-4">
                                <div className="footer-widget">
                                    <h5 className="mb-4 text-primary font-secondary"><L>Additional Links</L></h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2">
                                            <a href="https://dashboardone.taplocalnow.com/Tap/Account/Login">
                                                <L>Merchant Dashboard</L>
                                            </a>
                                        </li>
                                        <li className="mb-2">
                                            <a href="https://taplocalnow.com/legal/">
                                                <L>Terms of Service</L>
                                            </a>
                                        </li>
                                        <li className="mb-2">
                                            <a href="https://taplocalnow.com/legal/privacy-notice/">
                                                <L>Privacy Policy</L>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-12 newsletter-form">
                                <div style={{ backgroundColor: '#50be4d', borderRadius: '19px', padding: '30px' }}>

                                    <iframe width="100%" height="250" src="https://www.youtube.com/embed/i4S67WQPqKQ?si=UbOxdpsaj_hZoCmX" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

                                </div>
                            </div>

                        </div>
                        <div className="row align-items-center mt-5 text-center text-md-start">
                            <div className="col-lg-4">
                                <Link to="/">
                                    <img loading="prelaod" decoding="async" className="img-fluid" width="160" src="/img/landing/logo.png" alt="Wallet" />
                                </Link>
                            </div>
                            <div className="col-lg-4 col-md-6 mt-4 mt-lg-0">
                                <ul className="list-unstyled list-inline mb-0 text-lg-center">
                                    <li className="list-inline-item me-4">
                                        TAP Web Builder © <script>{new Date().getFullYear()}</script> | <a className="text-black" target="_blank" rel="noreferrer" href="https://taplocalnow.com">Powered by TAPLocal</a>
                                    </li>
                                    <li className="list-inline-item me-4">
                                        <a className="text-black" target="_blank" rel="noreferrer" href="https://taplocalnow.com/legal/privacy-notice/"><L>Privacy Policy</L></a>
                                        <a className="text-black" target="_blank" rel="noreferrer" href="https://taplocalnow.com/legal/terms-of-use/"><L>Terms of Use</L></a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-4 col-md-6 text-md-end mt-4 mt-md-0">
                                <ul className="list-unstyled list-inline mb-0 social-icons">
                                    <li className="list-inline-item me-3">
                                        <a title="Facebook Profile" className="text-black" target="_blank" rel="noreferrer" href="https://www.facebook.com/taplocalnow">
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li className="list-inline-item me-3">
                                        <a title="Instagram Profile" className="text-black" target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/taplocalnow/posts/?feedView=all">
                                            <i className="fab fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li className="list-inline-item me-3">
                                        <a title="YouTube" className="text-black" target="_blank" rel="noreferrer" href="https://www.youtube.com/@taplocal5136">
                                            <i className="fab fa-youtube"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </>
        );
    }
}

export default withParamsAndNavigate(LandingLayout);